import classNames from 'classnames';
import * as React from 'react';

import css from './Button.module.scss';

interface Props extends React.HTMLProps<{}> {
  href?: string;
  onClick?: (event: React.MouseEvent) => void;
  // tslint:disable-next-line: no-any
  tag?: any;
  isFull: boolean;
  isGhost: boolean;
  buttonSize: ButtonSize;
  buttonColor: ButtonColor;
}

export enum ButtonSize {
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
}

export enum ButtonColor {
  Primary = 'primary',
  Biz = 'biz',
  White = 'white',
  WhiteBiz = 'whiteBiz',
}

class Button extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    buttonColor: ButtonColor.Primary,
    buttonSize: ButtonSize.Small,
    isGhost: false,
    isFull: false,
  };

  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick(event: React.MouseEvent) {
    const { disabled, onClick } = this.props;

    if (disabled) {
      event.preventDefault();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  }

  private decideTag() {
    const { tag, ...attr } = this.props;
    let Tag = tag || 'button';
    if (attr.href && Tag === 'button') {
      Tag = 'a';
    }
    return Tag;
  }

  private makeClasses(): string {
    const { className, isGhost, buttonSize, buttonColor, isFull } = this.props;

    const classes = classNames(
      css.Button,
      { [css.isFull]: isFull },
      { [css.isGhost]: isGhost },
      { [css.isXSmall]: buttonSize === ButtonSize.XSmall },
      { [css.isMedium]: buttonSize === ButtonSize.Medium },
      { [css.isLarge]: buttonSize === ButtonSize.Large },
      { [css.isXLarge]: buttonSize === ButtonSize.XLarge },
      { [css.isBiz]: buttonColor === ButtonColor.Biz },
      { [css.isWhite]: buttonColor === ButtonColor.White },
      { [css.isWhiteBiz]: buttonColor === ButtonColor.WhiteBiz },
      className,
    );

    return classes;
  }

  public render() {
    const {
      disabled,
      isGhost,
      isFull,
      buttonSize,
      buttonColor,
      ...attr
    } = this.props;
    const Tag = this.decideTag();
    const classes = this.makeClasses();

    return (
      <Tag
        {...attr}
        className={classes}
        disabled={disabled}
        onClick={this.handleClick}
      />
    );
  }
}

export default Button;
